import React from 'react';
import PropTypes from 'prop-types';
import {MuiThemeProvider, createMuiTheme} from 'material-ui/styles';
import amber from 'material-ui/colors/amber';
import blue from '../../../common/material-ui-colors/blue';

const theme = createMuiTheme({
	palette: {
		primary: blue,
		secondary: amber
	}
});

const Theme = ({children}) => (
	<MuiThemeProvider theme={theme}>
		{children}
	</MuiThemeProvider>
);

Theme.propTypes = ({
	children: PropTypes.array.isRequired
});

export default Theme;



// WEBPACK FOOTER //
// ./src/client/components/main/layout/theme/index.jsx